// FeedStoryMore.js
import FeedStoryProvider from '../container/FeedStoryProvider.js';
import StoryMore from '../page/StoryMore.jsx';

export default FeedStoryProvider(StoryMore);
